// api.js

import http from "../utils/http";
//let request = '/apiIP'; //https://www.chbim.cn/getList.json  //请求本地文件
//let postUrl ="/postURL/info/supplement"; // http://10.0.0.3:8080/postURL/info/supplement  //跨域--代理请求

let request = "/baseIP";

let bimsso_url = process.env.VUE_APP_BIMSSO_API;

// 获取token
export function getToken() {
  return http.post(
    "https://bimsso.ccshcc.cn:7000/api/GetToken?clientid=roadserver&clientsecret=road"
  );
}

//跨域请求示例代码。
// export function userLoginAPI(params){
//     return http.get(`${request}/home/userLogin`,params)
// }

//get 请求。
//短信验证。
// export function sendVerificationAPI2API(params){
//     return http.get(`${request}/home/sendVerificationAPI2`,params)
// }

//获取当前登录用户所能看到的项目列表信息。
export function getUserProjects(params) {
  return http.get(`${request}/getUserProjects`, params);
}

//获取当前用户登录信息。
export function getLoginUser(params) {
  return http.get(`${request}/getLoginUser`, params);
}
// 根据账号 密码 获取手机号和验证码
// export function getPhoneSmsCaptcha(params) {
//   return http.get(`${request}/getPhoneSmsCaptcha`, params);
// }

// 根据账号 密码 获取手机号和验证码
export function getPhoneSmsCaptcha(params) {
  return http.post(`${request}/getPhoneSmsCaptcha`, params);
}

//清理菜单缓存
export function clearUserCache(params) {
  return http.post(`${request}/BimProjectMenu/clearUserCache`, params);
}

// 获取主界面模型目录树。
export async function getProjectBimModel(params) {
  return await http.get(`${request}/BimModel/projectBimModel`, params);
}

// 获取标记信息列表【注意标记列表和标注列表不同】。
export function getMarkList(params) {
  return http.get(`${request}/BimMark/list`, params);
}

// 预留。
// 获取视频监控信息列表。
export function bimVideo(params) {
  return http.get(`${request}/BimVideoCategory/TreeNodeList`, params);
}

// 获取监测数据树形列表。
export function getBimMonitorTree(params) {
  return http.get(`${request}/BimMonitorUnit/TreeNodeList`, params);
}
// 获取监测项数据列表。
// export function getBimMonitorItemList(params){
// 	return http.get(`${request}/BimMonitorItem/list`, params);
// }
// 获取线型监测点列表数据列表。
export function getBimMonitorPointDoubleDataList(params) {
  return http.get(`${request}/BimMonitorPointDoubleData/list`, params);
}
// 获取监测图表信息点数据（传点id，用于线型监测和横竖方向监测外的其它类型监测）。
export function getMonitorNonlinearityDetail(params) {
  return http.get(`${request}/BimMonitorItem/detail`, params);
}
// 获取位移监测点列表（横竖方向监测数据）。
export function getMonitorCSDList(params) {
  return http.get(`${request}/BimMonitorCategorySingleData/list`, params);
}

// 预留。
// 获取征拆管理信息列表。
export function getBimDemolition(params) {
  return http.get(`${request}/BimDemolitionCategory/tree`, params);
}

// 预留。
// 获取变更管理信息列表。
export function getBimEngineeringChange(params) {
  return http.get(`${request}/BimEngineeringChangeItem/TreeNodeList`, params);
}
// 获取变更管理变更项明细表
export function getBimengineeringchangeitemdetail(params) {
  return http.get(`${request}/BimEngineeringChangeItemDetail/list`, params);
}
// 变更管理造价列表查询
export function BimEngineeringChangeItemCost(params) {
  return http.get(`${request}/BimEngineeringChangeItemCost/list`, params);
}
//变更项下载接口
export function BimEngineeringChangeItemDetail(params) {
  return http.get(`${request}/BimEngineeringChangeItemDetail/export`, params);
}
//获取文件详情。
export function getFileDetail(params) {
  return http.get(`${request}/sysFileInfo/detail`, params);
}
//获取文件列表【根据业务类型和业务id获取，资料库中有用到】。
export function getFileList(params) {
  return http.get(`${request}/sysFileInfo/list`, params);
}

//GIS信息服务 获取BimProject列表。
export async function getProjectGisInfo(params) {
  return await http.get(`${request}/BimModel/projectGisInfo`, params);
}

//Shp数据信息服务 获取ShpInfo树列表。
export function getProjectShpInfo(params) {
  return http.get(`${request}/ShpInfo/projectShpInfo`, params);
}

//地形修改数据服务 获取GisModify树列表。
export function getProjectGisModify(params) {
  return http.get(`${request}/GisModify/projectGisModify`, params);
}

//地形修改数据服务 获取GisModify列表。
//现在的/GisModify/list接口没有区分项目id，所以现在改用分页方法不传page的方式获取列表。
export function getProjectPageGisModify(params) {
  return http.get(`${request}/GisModify/page`, params);
}

//分页查询自定义漫游路径信息。
export function selectRoaming(params) {
  return http.get(`${request}/BimRoam/page`, params);
}
//查询自定义漫游路径信息详情【获取漫游路线数据】。
export function selectRoamingDetail(params) {
  return http.get(`${request}/BimRoam/detail`, params);
}
//分页查询自定义漫游点位信息。
export function selectRoamingPoint(params) {
  // return http.get(`${request}/BimRoamPoints/page`,params);
  return http.get(`${request}/BimRoamPoints/list`, params);
}
export function selectRoamingPointpage(params) {
  return http.get(`${request}/BimRoamPoints/page`, params);
}
//查询自定义漫游点位信息详情【编辑表单信息展示】。
export function selectRoamingPointDetail(params) {
  return http.get(`${request}/BimRoamPoints/detail`, params);
}

//获取文字标注信息列表。
export async function getKmlInfo(params) {
  return await http.get(`${request}/KmlInfo/projectKmlInfo`, params);
}

// // 获取模型的属性列表。
// export function getModelPropertyList(params){
//     return http.get(`${request}/home/getPropertyListAPI`,params)
// }
// // 获取 MBS目录树列表。
// export function getMBSList(params){
//     return http.get(`${request}/home/getMBSListAPI`,params)
// }

// 获取资料库目录表列表。
// export function getBimDataBankCategoryList(params){
// 	return http.get(`${request}/BimDataBankCategory/list`, params);
// }
// 分页获取资料库目录表列表。
export function getBimDataBankCategoryPage(params) {
  return http.get(`${request}/BimDataBankCategory/page`, params);
}
// 获取资料库目录详情。
export function getBimDataBankCategoryDetail(params) {
  return http.get(`${request}/BimDataBankCategory/detail`, params);
}
// 获取资料库目录树结构数据。
export function getBimDataBankCategoryTree(params) {
  return http.get(`${request}/BimDataBankCategory/TreeNodeList`, params);
}
// 新获取资料库目录树结构数据。
export function getBimDataBankCategoryTreeNew(params) {
  return http.get(`${request}/BimDataBankCategory/TreeNodeListLazy`, params);
}
// 根据资料库目录id查找其父级目录列表。
export function getBimDataBankCategoryPC(params) {
  return http.get(`${request}/BimDataBankCategory/FindParentList`, params);
}
// 根据资料库目录id查找其下级目录树。【本接口临时作为方便快速完成功能使用，应该是可以不用此接口亦能完成功能的。】
export function getBimDataBankCategoryCC(params) {
  return http.get(`${request}/BimDataBankCategory/FindChildrenList`, params);
}

// 获取资料库常用目录列表。
export function getBimDatabankCommonCategoryList(params) {
  return http.get(`${request}/BimDatabankCommonCategory/list`, params);
}

// 地形开挖
// 获取当前项目的所有挖坑数据(tree)
export function getBimModelExcavationTreeNodeList(params) {
  return http.get(`${request}/BimModelExcavationDetails/TreeNodeList`, params);
}

// 关于地形开挖的新增时搜索节点(远程搜索)
export function searchBimModelNode(params) {
  return http.get(`${request}/BimModel/list`, params);
}

// 关于地形开挖的新增时搜索分组(远程搜索)
export function searchBimModelNodeGrouping(params) {
  return http.get(`${request}/BimModelExcavationDetails/SecondaryList`, params);
}

// 新增地形开挖数据（与节点相关联）
export function addBimModelExcavationDetails(params) {
  return http.post(`${request}/BimModelExcavationDetails/add`, params);
}

// 删除地形开挖数据（与节点相关联）
export function deleteBimModelExcavationDetails(params) {
  return http.post(`${request}/BimModelExcavationDetails/delete`, params);
}

// 更新地形开挖数据（与节点相关联）
export function editBimModelExcavationDetails(params) {
  return http.post(`${request}/BimModelExcavationDetails/edit`, params);
}

// 地形开挖根据2级id（kml文件上传的id）查找三级数据
export function searchSecondExcavationDetails(params) {
  return http.get(`${request}/BimModelExcavationDetails/list`, params);
}

// 地形开挖根据单个id（kml文件上传的id）查找数据
export function getExcavationDetail(params) {
  return http.get(`${request}/BimModelExcavationDetails/detail?id=${params}`);
}
// 临时保留。
// // 获取资料库常用目录树结构数据列表。
// export function getBimDatabankCommonCategoryTree(params){
// 	return http.get(`${request}/BimDataBankCategory/TreeNodeList`, params);
// }
// // 获取资料库常用目录分页列表。
// export function getBimDatabankCommonCategoryPage(params){
// 	return http.get(`${request}/BimDatabankCommonCategory/page`, params);
// }
// // 获取资料库常用目录详情。
// export function getBimDatabankCommonCategoryDetail(params){
// 	return http.get(`${request}/BimDatabankCommonCategory/detail`, params);
// }

// 获取资料库资料项列表。
export function getBimDataBankDataList(params) {
  return http.get(`${request}/BimDataBankData/list`, params);
}
// 获取资料库资料项分页列表。
export function getBimDataBankDataPage(params, sourceToken) {
  return http.get(`${request}/BimDataBankData/page`, params, sourceToken);
}
// 获取资料库资料项详情。
export function getBimDataBankDataDetail(params) {
  return http.get(`${request}/BimDataBankData/detail`, params);
}

//POST请求。
//登录验证。
export function userLoginAPI(params) {
  //return http.get(`${request}/home/userLogin`,params)
  return http.post(`${request}/login`, params);
}
//登录验证 4A
export function postlogin4AApi(params) {
  return http.post(`${request}/login4A`, params);
}

//获取随机验证码。
export function getCaptchaCode() {
  return http.post(`${request}/captcha/get`);
}
//验证随机验证码。
export function checkCaptchaCode(params) {
  return http.post(`${request}/captcha/check`, params);
}
//获取短信验证码是否发送成功的结果。
export function getSmsCaptchaResult(params) {
  return http.post(`${request}/getSmsCaptcha`, params);
}
//短信验证登录
export function getSmsCaptcha(params) {
  return http.post(`${request}/smsCaptcha/check`, params);
}

//增加标记/标记目录【现在标记和标记目录放在同一张数据表上】。
export function addMark(params) {
  return http.post(`${request}/BimMark/add`, params);
}
//编辑标记/标记目录。
export function editMark(params) {
  return http.post(`${request}/BimMark/edit`, params);
}
//删除标记/标记目录。
export function deleteMark(params) {
  return http.post(`${request}/BimMark/delete`, params);
}
//根据文件id删除上传的文件。
export function deleteFile(params) {
  return http.post(`${request}/sysFileInfo/delete`, params);
}

// 预留。
// 增加视频监控点。
export function addSurveil(params) {
  return http.post(`${request}/BimVideoCamera/add`, params);
}
// 编辑视频监控点。
export function editSurveil(params) {
  return http.post(`${request}/BimVideoCamera/edit`, params);
}
// 删除视频监控点。
export function deleteSurveil(params) {
  return http.post(`${request}/BimVideoCamera/delete`, params);
}
// 新增视频监控分类。
export function addBimVideoCategory(params) {
  return http.post(`${request}/BimVideoCategory/add`, params);
}
// 删除视频监控分类。
export function deleteBimVideoCategory(params) {
  return http.post(`${request}/BimVideoCategory/delete`, params);
}
// 编辑视频监控分类。
export function editBimVideoCategory(params) {
  return http.post(`${request}/BimVideoCategory/edit`, params);
}

// 预留
// 增加监测点/监测点目录。
export function addMonitor(params) {
  return http.post(`${request}/VideoMonitor/add`, params);
}
//编辑监测点/监测点目录。
export function editMonitor(params) {
  return http.post(`${request}/VideoMonitor/edit`, params);
}
//删除监测点/监测点目录。
export function deleteMonitor(params) {
  return http.post(`${request}/VideoMonitor/delete`, params);
}
// 获取监测图表信息点数据（传点id数组，用于获取线型监测单个监测点的详情数据）。
export function getMonitorLineTypePoints(params) {
  return http.post(`${request}/BimMonitorPointDoubleData/points`, params);
}

// 预留
// 获取征拆区域树结构数据。
export function getDemolition(params) {
  return http.get(`${request}/demolition/tree`, params);
}
// 增加征拆区域目录。
export function addDemolition(params) {
  return http.post(`${request}/demolition/category/add`, params);
}
// 编辑征拆区域目录。
export function editDemolition(params) {
  return http.post(`${request}/demolition/category/edit`, params);
}
// 删除征拆区域目录。
export function deleteDemolition(params) {
  return http.post(`${request}/demolition/category/delete`, params);
}
// 编辑征拆区域单块征拆区域详情信息。
export function editDemolitionBlock(params) {
  return http.post(`${request}/demolition/block/edit`, params);
}

export function addDemolitionArea(params) {
  return http.post(`${request}/BimDemolitionArea/add`, params);
}
export function editDemolitionArea(params) {
  return http.post(`${request}/demolition/area/edit`, params);
}
//删除征拆区域。
export function deleteDemolitionArea(params) {
  return http.post(`${request}/demolition/area/delete`, params);
}
// 预留
// 增加变更管理项/变更管理目录。
export function addBimEngineeringChangeItem(params) {
  return http.post(`${request}/BimEngineeringChangeItem/add`, params);
}
//编辑变更管理项/变更管理目录。
export function editBimEngineeringChangeItem(params) {
  return http.post(`${request}/BimEngineeringChangeItem/edit`, params);
}
//删除变更管理项/变更管理目录。
export function deleteBimEngineeringChangeItem(params) {
  return http.post(`${request}/BimEngineeringChangeItem/delete`, params);
}
// 变更管理项上传
export function BimChangeClassification(params) {
  return http.post(`${request}//sysFileInfo/uploadmultiple`, params);
}

//增加自定义漫游路径信息。
export function addRoaming(params) {
  return http.post(`${request}/BimRoam/add`, params);
}
//修改自定义漫游路径信息。
export function editRoaming(params) {
  return http.post(`${request}/BimRoam/edit`, params);
}
//删除自定义漫游路径信息。
export function deleteRoaming(params) {
  return http.post(`${request}/BimRoam/delete`, params);
}
//增加自定义漫游路径点位信息。
export function addRoamingPoint(params) {
  return http.post(`${request}/BimRoamPoints/add`, params);
}
//修改自定义漫游路径点位信息。
export function editRoamingPoint(params) {
  return http.post(`${request}/BimRoamPoints/edit`, params);
}
//删除自定义漫游路径点位信息。
export function deleteRoamingPoint(params) {
  return http.post(`${request}/BimRoamPoints/delete`, params);
}

// 增加资料库目录。
export function addBimDataBankCategory(params) {
  return http.post(`${request}/BimDataBankCategory/add`, params);
}
// 编辑资料库目录。
export function editBimDataBankCategory(params) {
  return http.post(`${request}/BimDataBankCategory/edit`, params);
}
// 删除资料库目录。
export function deleteBimDataBankCategory(params) {
  return http.post(`${request}/BimDataBankCategory/delete`, params);
}

// 增加资料库常用目录。
export function addBimDatabankCommonCategory(params) {
  return http.post(`${request}/BimDatabankCommonCategory/add`, params);
}
// 编辑资料库常用目录。
export function editBimDatabankCommonCategory(params) {
  return http.post(`${request}/BimDatabankCommonCategory/edit`, params);
}
// 根据常用目录数据表的主键id删除资料库常用目录。
export function deleteBimDatabankCommonCategory(params) {
  return http.post(`${request}/BimDatabankCommonCategory/delete`, params);
}
// 根据目录id和projectid来删除资料库常用目录数据表里的数据。
export function deleteBimDatabankCommonCategoryByCId(params) {
  return http.post(
    `${request}/BimDatabankCommonCategory/deleteForCategoryId`,
    params
  );
}

// 增加资料库资料项。
export function addBimDataBankData(params) {
  return http.post(`${request}/BimDataBankData/add`, params);
}
// 编辑资料库资料项。
export function editBimDataBankData(params) {
  return http.post(`${request}/BimDataBankData/edit`, params);
}
// 删除资料库资料项。
export function deleteBimDataBankData(params) {
  return http.post(`${request}/BimDataBankData/delete`, params);
}

//上传文件
export function uploadOneFile(params) {
  return http.post(`${request}/sysFileInfo/upload`, params);
}

//预留方法 结束。

//post 请求。
// export function postFormAPI(params){
//     return http.post(`${postUrl}`,params)
// }

//put 请求。
// export function putSomeAPI(params){
//     return http.put(`${request}/putSome.json`,params)
// }

//delete 请求。
// export function deleteListAPI(params){
//     return http.delete(`${request}/deleteList.json`,params)
// }

// 系统菜单服务
export async function menuChange(params) {
  return await http.post(`${request}/BimProjectMenu/change`, params);
}
// /BimProjectMenu/change

/*  
  视频漫游-路线
*/
export function getBimVideoRoamingNodeList(params) {
  return http.get(`${request}/BimVideoRoamingNode/TreeNodeList`, params);
}
export function addBimVideoRoamingNode(params) {
  return http.post(`${request}/BimVideoRoamingNode/add`, params);
}
export function editBimVideoRoamingNode(params) {
  return http.post(`${request}/BimVideoRoamingNode/edit`, params);
}
export function deleteBimVideoRoamingNode(params) {
  return http.post(`${request}/BimVideoRoamingNode/delete`, params);
}
export function addBimVideoRoamingContent(params) {
  return http.post(`${request}/BimVideoRoamingContent/add`, params);
}
export function editBimVideoRoamingContent(params) {
  return http.post(`${request}/BimVideoRoamingContent/edit`, params);
}
export function deleteBimVideoRoamingContent(params) {
  return http.post(`${request}/BimVideoRoamingContent/delete`, params);
}
export function getBimDataBankDataLefiilst(params) {
  return http.get(`${request}/BimDataBankData/flieList`, params);
}

/*  
  方案
*/
// 添加 方案分组
export function addBimPlanGrouping(params) {
  return http.post(`${request}/BimPlanGrouping/add`, params);
}
// 删除 方案分组
export function deleteBimPlanGrouping(params) {
  return http.post(`${request}/BimPlanGrouping/delete`, params);
}
// 编辑 方案分组
export function editBimPlanGrouping(params) {
  return http.post(`${request}/BimPlanGrouping/edit`, params);
}
// 编辑 方案场景名
export function editBimPlanSceneName(params) {
  return http.post(`${request}/BimPlanScenes/editNmae`, params);
}
// 复制 方案分组
export function copyBimPlanGrouping(params) {
  return http.post(`${request}/BimPlanGrouping/copyPlanGrouping`, params);
}

// 获取项目下所有的方案和分组 -- 二层级
export function getBimPlanAllGrouping(params) {
  return http.get(`${request}/BimPlan/TreeNodeList`, params);
}

// 展示
export function treeNodeList(params) {
  return http.get(`${request}/BimPlanGrouping/TreeNodeList`, params);
}
// 展示资源树
export function getScenesTreeNodeList(params) {
  return http.get(`${request}/BimPlanScenes/scenesTreeNodeList`, params);
}
export function getDLdinooprstw(params) {
  return http.get(`${request}//BimPlanGrouping/DLdinooprstw`, params);
}

// 增加方案场景
export function addBimPlanScenes(params) {
  return http.post(`${request}/BimPlanScenes/add`, params);
}
// 删除方案场景
export function deleteBimPlanScenes(params) {
  return http.post(`${request}/BimPlanScenes/delete`, params);
}
// 编辑方案场景
export function editBimPlanScenes(params) {
  return http.post(`${request}/BimPlanScenes/edit`, params);
}

// 标绘分组数据
export function getPlotItemGroupListService(params) {
  return http.get(`${request}/BimPlanPainting/TreeNodeList`, params);
}
// 新增标绘
export function addedBimPlottedData(params) {
  return http.post(`${request}/BimPlanPainting/add`, params);
}
export function cloneSceneBimPlanPainting(params) {
  return http.post(`${request}/BimPlanPainting/cloneScene`, params);
}

// 获取标绘详情数据
export function detailBimPlottedData(id) {
  return http.get(`${request}/BimPlanPainting/detail?id=${id}`);
}
// 编辑提交标绘
export function editBimPlottedData(params) {
  return http.post(`${request}/BimPlanPainting/edit`, params);
}
// 删除标绘
export function deteleBimPlottedData(params) {
  return http.post(`${request}/BimPlanPainting/delete`, params);
}

// 图片资源上传（）
export function scence(params) {
  return http.post(`${request}/BimPlanScenesFile/add`, params);
}

//图片资源信息修改
export function imgEdit(params) {
  return http.post(`${request}/BimPlanScenesFile/edit`, params);
}

//图片查找已上传
export function getImgItemList(params) {
  return http.get(`${request}/BimPlanScenesFile/list`, params);
}

// 删除图片验证
export function delImgVerificationList(params) {
  return http.get(`${request}/BimPlanScenesFile/checkBeforeDelete`, params);
}
// 删除一行图片
export function delImgList(params) {
  return http.post(`${request}/BimPlanScenesFile/delete`, params);
}

// 图片·新增资源标绘
export function addResoucePlot(params) {
  return http.post(`${request}/BimPlanScenesFile/flieList`, params);
}

export function getDropDownList(params) {
  return http.get(`${request}/BimModel/dropDownTreeList`, params);
}

export function getKmlDropDownList(params) {
  return http.get(`${request}/KmlInfo/dropDownTreeList`, params);
}

export function getShpInfoDropDownList(params) {
  return http.get(`${request}/ShpInfo/dropDownTreeList`, params);
}

export function getBimPlanPaintingDropDownList(params) {
  //return http.get(`${request}/BimPlanPainting/dropDownList`, params);
  return http.get(`${request}/BimPlanPainting/dropDownTreeList`, params);
}

export function addBimPlanScenesMethod(params) {
  return http.post(`${request}/BimPlanScenesMethod/add`, params);
}

export function editBimPlanScenesMethod(params) {
  return http.post(`${request}/BimPlanScenesMethod/edit`, params);
}

export function getBimPlanScenesMethodList(params) {
  return http.get(`${request}/BimPlanScenesMethod/list`, params);
}

export function postBimPlanScenesMethodListDeletes(params) {
  return http.post(`${request}/BimPlanScenesMethod/delete`, params);
}

export function postBimPlanScenesMethodeditSort(params) {
  return http.post(`${request}/BimPlanScenesMethod/editSort`, params);
}

export function postBimPlanGroupingEditSort(params) {
  return http.post(`${request}/BimPlanGrouping/editSort`, params);
}

export function postBimPlanScenesEditSort(params) {
  return http.post(`${request}/BimPlanScenes/editSort`, params);
}

//获取当前项目平台设置信息。
export function getProjectSettings(params) {
  return http.get(`${request}/BimProject/detail`, params);
}

export function getBimPlanDetail(params) {
  return http.get(`${request}/BimPlan/detail`, params);
}
//修改当前项目平台设置信息。
export function postProjectSettingsedit(params) {
  return http.post(`${request}/BimProject/editEntity`, params);
}

// 模型添加到场景里
export function addBimPlanScenesBusiness(params) {
  return http.post(`${request}/BimPlanScenesBusiness/addList`, params);
}
// 模型添加到场景里验证
export function checkBeforeAddList(params) {
  return http.post(
    `${request}/BimPlanScenesBusiness/checkBeforeAddList`,
    params
  );
}
// 标绘私有删除校验
export function plotPrivateCheckBeforeAddList(params) {
  return http.get(`${request}/BimPlanPainting/checkBeforeDelete`, params);
}
// 标绘公共删除校验
export function plotCheckBeforeAddList(params) {
  return http.get(`${request}/BimPlanScenesBusiness/checkBusiness`, params);
}

// 标绘clone
export function clonePlotData(params) {
  return http.post(`${request}/BimPlanPainting/clone`, params);
}

// 获取挖坑数据
export function getDropDownTreeList(params) {
  return http.get(
    `${request}/BimModelExcavationDetails/dropDownTreeList`,
    params
  );
}
//项目数据信息服务 获取KmlAndShpInfo树列表。
export function getProjectKmlAndShpInfo(params) {
  return http.get(`${request}/KmlInfo/KmlAndShpTreeNodeList`, params);
}

// KML新增分组
export function addKmlInfo(params) {
  return http.post(`${request}/KmlInfo/add`, params);
}

// SHP新增分组
export function addShpInfo(params) {
  return http.post(`${request}/ShpInfo/add`, params);
}

// KML编辑分组
export function editKmlInfo(params) {
  return http.post(`${request}/KmlInfo/edit`, params);
}
// KML更新数据
export function updateKmlInfo(params) {
  return http.post(`${request}/KmlInfo/editFile`, params);
}

// SHP编辑分组
export function editShpInfo(params) {
  return http.post(`${request}/ShpInfo/edit`, params);
}

// SHP更新数据
export function updateShpInfo(params) {
  return http.post(`${request}/ShpInfo/editFile`, params);
}

// 获取KML和SHP分组
export function KmlInfoFkKmlInfoList(params) {
  return http.get(`${request}/KmlInfo/fkKmlInfo?projectId=${params}`);
}

export function ShpInfoFkSmlInfoList(params) {
  return http.get(`${request}/ShpInfo/fkShpInfo?projectId=${params}`);
}

// KML和SHP的删除
export function deleteKmlList(params) {
  return http.post(`${request}/KmlInfo/delete`, params);
}

export function deleteShpList(params) {
  return http.post(`${request}/ShpInfo/delete`, params);
}

// SHP材质下拉框数据
export function sysDictTypeDropDown(parameter) {
  return http.get(`${request}/sysDictType/dropDown?code=${parameter}`);
}

export function copyPlanScenes(params) {
  return http.post(`${request}/BimPlanScenes/copyPlanScenes`, params);
}

// 获取场景分组下拉数据源
export function getDropDownGroupingList(params) {
  return http.get(`${request}/BimPlanGrouping/dropDownList`, params);
}

// 获取场景分组下拉数据源
export async function getBimModelAttributesList(params) {
  return await http.get(`${request}/BimModelAttributes/list`, params);
}

// 获取模型属性列表图纸
export function getDrawingUrl(params) {
  return http.get(`${request}/DuAnDrawing/getDrawingUrl`, params);
}
// 获取都安质量属性
export function getDuAnQualityFamilyList(params) {
  return http.get(`${request}/DuAnQualityFamily/list`, params);
}
// 获取构件属性列表建设属性进度list
export function getDuAnProcessList(params) {
  return http.get(`${request}/DuAnProcess/list`, params);
}
// 获取构件属性列表建设属性安全（巡检安全list）
export function getDuAnInspectionSecurityList(params) {
  return http.get(`${request}/DuAnSafeCheck/list`, params);
}
// 获取构件属性列表建设属性安全（跟踪风险list）
export function getDuAnTrackingRiskList(params) {
  return http.get(`${request}/DuAnSafeTrack/list`, params);
}
// 获取构件属性列表建设属性安全（造价list）
export function getDuAnCostFamilyList(params) {
  return http.get(`${request}/DuAnCostFamily/list`, params);
}

export function getBimPlanScenesDetail(params) {
  return http.get(`${request}/BimPlanScenes/detail`, params);
}
// 获取都安质量属性证书属性明细
export function getDuAnQualityDetailsList(params) {
  return http.get(`${request}/DuAnQualityDetails/list`, params);
}

// 获取都安质量属性证书属性明细其他
export function getDuAnQualityOthersList(params) {
  return http.get(`${request}/DuAnQualityOthers/list`, params);
}

// 获取都安质量属性证书属性明细其他
export function getDuAnQualityOthersDetailsList(params) {
  return http.get(`${request}/DuAnQualityOtherDetails/list`, params);
}

// 解析施工模拟数据
export function parseConstruct(params) {
  return http.post(`${request}/BimSimConstruct/ParseConstruct`, params);
}
//获取施工模拟分类单个树
export function bimSimConstructGetTree(params) {
  return http.get(`${request}/BimSimConstruct/GetTree`, params);
}
//获取时间线
export function bimSimConstructGTeeeiilmnt(params) {
  return http.get(`${request}/BimSimConstruct/GetTimeline`, params);
}
//获取时间线 树
export function bimSimConstructGetTimelineTree(params) {
  return http.get(`${request}/BimSimConstruct/GetTimelineTree`, params);
}
//删除施工模拟方案全局信息
export function bimSimConstructDeeelt(params) {
  return http.post(`${request}/BimSimConstruct/Delete`, params);
}
//获取交通模拟对象实体
export function bimSimConstructObjectsDetail(params) {
  return http.get(`${request}/BimSimConstructObjects/detail`, params);
}
//获取交通模拟车道实体列表
export function BimSimConstructRoadwayList(params) {
  return http.get(`${request}/BimSimConstructRoadway/list`, params);
}
//获取交通模拟车道点集合列表
export function bimSimConstructRoadwayDetailList(params) {
  return http.get(`${request}/BimSimConstructRoadwayDetail/list`, params);
}
//获取交通模拟对象实体
export function BimSimConstructObjectsDetail(params) {
  return http.get(`${request}/BimSimConstructObjects/detail`, params);
}
//获取交通模拟停车区实体
export function BimSimConstructParkingDetail(params) {
  return http.get(`${request}/BimSimConstructParking/detail`, params);
}
///获取模拟交通转换实体
export function BimSimConstructTransferPartDetail(params) {
  return http.get(`${request}/BimSimConstructTransferPart/detail`, params);
}
//工点
export function BimSimConstructWorkPntsDetail(params) {
  return http.get(`${request}/BimSimConstructWorkPnts/detail`, params);
}

// 新百米桩查询
export function getMileageStakesAndPoints(params) {
  return http.get(`${bimsso_url}/API/GetMileageStakesAndPoints`, params);
}

// 根据项目返回方案集合
export function getPlansService(params) {
  return http.get(`${bimsso_url}/API/GetPlans`, params);
}
// 根据方案返回设计线集合
export function getLineByPlanService(params) {
  return http.get(`${bimsso_url}/API/getLineByPlan`, params);
}
// 根据方案、设计线、点位，获取信息
export function getStakeByBLHService(params) {
  return http.get(`${bimsso_url}/API/GetStakeInfoByBLH`, params);
}
// 根据方案、设计线、点位，获取信息
export function getGetStakeByBLH(params) {
  return http.get(`${bimsso_url}/API/GetStakeByBLH`, params);
}
// 根据方案、设计线、桩号，获取经纬度坐标
export function getPointService(params) {
  return http.get(`${bimsso_url}/API/getCenterStakeCoord`, params);
}
// 根据间距得到设计线上的点
export function getPointsBySpacingService(params) {
  return http.get(`${bimsso_url}/API/getPointsBySpacing`, params);
}
// 根据间距得到设计线上的点
export function getCrossSectionByLineService(params) {
  return http.get(`${bimsso_url}/API/getCrossSectionByLine`, params);
}
// 根据间距得到设计线上的点
export function getVolumeService(params) {
  return http.get(`${bimsso_url}/API/GetEarthworks`, params);
}
// 根据方案、设计线、坐标，得到土石方面积
export function getsectionAreaByLineService(params) {
  return http.get(`${bimsso_url}/API/getsectionAreaByLine`, params);
}
// 根据方案、设计线，获得设计线线元（平面以主线为准）
export function getElementsService(params) {
  return http.get(`${bimsso_url}/API/getElements`, params);
}

// 交通模拟树形
export function getTreeNodeList(params) {
  return http.get(`${request}/BimTrafficSimulationNode/TreeNodeList`, params);
}
// 添加交通模拟
export function addTdeeeiorst(params) {
  return http.post(`${request}/BimTrafficSimulationNode/add`, params);
}
// 删除交通模拟
export function deleteTdeeeiorst(params) {
  return http.post(`${request}/BimTrafficSimulationNode/delete`, params);
}
// 编辑交通模拟
export function editTdeeeiorst(params) {
  return http.post(`${request}/BimTrafficSimulationNode/edit`, params);
}
// 编辑交通模拟
export function addBimTrafficSimulationContent(params) {
  return http.post(`${request}/BimTrafficSimulationContent/add`, params);
}
export function editBimTrafficSimulationContent(params) {
  return http.post(`${request}/BimTrafficSimulationContent/edit`, params);
}
export function deleteBimTrafficSimulationContent(params) {
  return http.post(`${request}/BimTrafficSimulationContent/delete`, params);
}
export function getBimTrafficSimulationNodeList(params) {
  return http.get(`${request}/BimTrafficSimulationNode/list`, params);
}

//视点
// 列表
export function BimViewPntsGroupingDetail(params) {
  return http.get(`${request}/BimViewPntsGrouping/detail`, params);
}
export function BimViewPntsGroupingAdd(params) {
  return http.post(`${request}/BimViewPntsGrouping/add`, params);
}
export function BimViewPntsGroupingDelete(params) {
  return http.post(`${request}/BimViewPntsGrouping/delete`, params);
}
export function BimViewPntsGroupingEdit(params) {
  return http.post(`${request}/BimViewPntsGrouping/edit`, params);
}
export function BimViewPntsDetailAdd(params) {
  return http.post(`${request}/BimViewPntsDetail/add`, params);
}
export function BimViewPntsDetailDelete(params) {
  return http.post(`${request}/BimViewPntsDetail/delete`, params);
}
// 评价指标

export function BimSimConstructDescDetail(params) {
  return http.get(`${request}/BimSimConstructDesc/detail`, params);
}
//获取施工模拟方案保通信息
export function BimSimConstructGetEnsurePass(params) {
  // return http.get(`${request}/BimSimConstruct/GetEnsurePass`, params);
  return http.get(`${request}/BimSimConstructSchema/detail`, params);
}
export function BimSimConstructAdd(params) {
  // return http.post(`${request}/BimSimConstruct/edit`, params);
  return http.post(`${request}/BimSimConstructSchema/add`, params);
}
export function BimSimConstructEdit(params) {
  // return http.post(`${request}/BimSimConstruct/edit`, params);
  return http.post(`${request}/BimSimConstructSchema/edit`, params);
}
///区段信息
export function BimSimConstructSectionsDetail(params) {
  return http.get(`${request}/BimSimConstructSections/detail`, params);
}
// 方案汇报服务
// 列表
export function getBimPlanList(params) {
  return http.get(`${request}/BimPlan/list`, params);
}
// 编辑
export function postBimPlanEdit(params) {
  return http.post(`${request}/BimPlan/edit`, params);
}
// 删除
export function postBimPlanDelete(params) {
  return http.post(`${request}/BimPlan/delete`, params);
}
// 增加
export function postBimPlanAdd(params) {
  return http.post(`${request}/BimPlan/Add`, params);
}

// 复制
export function postBimPlanCopy(params) {
  return http.post(`${request}/BimPlanGrouping/copyPlanGrouping`, params);
}

export function replicationScheme(params) {
  return http.post(`${request}/BimPlan/copyPlan`, params);
}

//获取施工模拟场景下的全部方案
export function bimSimConstructGLeistt(params) {
  return http.get(`${request}/BimSimConstruct/GetList`, params);
}
//获取施工模拟数据解析进度 获取ID
export function bimSimConstructGetProcessId(params) {
  return http.get(`${request}/BimSimConstruct/GetProcessId`, params);
}
//获取施工模拟数据解析进度
export function bimSimConstructGetProgress(params) {
  return http.get(`${request}/BimSimConstruct/GetProgress`, params);
}
//更新视点名称
export function BimViewPntsDetailEdit(params) {
  return http.post(`${request}/BimViewPntsDetail/edit`, params);
}

export function postSmsRstPw(params) {
  return http.post(`${request}/smsRstPw`, params);
}

export function getSysNoticeReceived(params) {
  return http.get(`${request}/sysNotice/receivedEntity`, params);
}

export function getSysNoticeDetail(params) {
  return http.get(`${request}/sysNotice/detail`, params);
}
//模型库
//获取模型库分组列表
export function BimGltfGroupingList(params) {
  return http.get(`${request}/BimGltfGrouping/list`, params);
}
//增加模型库分组
export function BimGltfGroupingAdd(params) {
  return http.post(`${request}/BimGltfGrouping/add`, params);
}
export function BimGltfGroupingDelete(params) {
  return http.post(`${request}/BimGltfGrouping/delete`, params);
}
export function BimGltfGroupingEdit(params) {
  return http.post(`${request}/BimGltfGrouping/edit`, params);
}
//增加模型库内容
export function BimGltfPaintingAdd(params) {
  return http.post(`${request}/BimGltfPainting/add`, params);
}
//删除模型
export function BimGltfPaintingDelete(params) {
  return http.post(`${request}/BimGltfPainting/delete`, params);
}
//更新模型库内容
export function BimGltfPaintingEdit(params) {
  return http.post(`${request}/BimGltfPainting/edit`, params);
}
export function BimSimWorkingGrowDetail(params) {
  return http.get(`${request}/BimSimWorkingGrow/detail`, params);
}
export function BimSimWorkingDetail(params) {
  return http.get(`${request}/BimSimWorking/detail`, params);
}

//模型剖切列表
export function getBimModeSlicedList(params) {
  return http.get(`${request}/BimModeSliced/list`, params);
}
//模型剖切 添加
export function postBimModeSlicedAdd(params) {
  return http.post(`${request}/BimModeSliced/add`, params);
}
//模型剖切 编辑
export function postBimModeSlicedEdit(params) {
  return http.post(`${request}/BimModeSliced/edit`, params);
}
//模型剖切 删除
export function postBimModeSlicedDelete(params) {
  return http.post(`${request}/BimModeSliced/delete`, params);
}
//分页查询工点模拟细节
export function BimSimWorkingPointsDetailPage(params) {
  return http.get(`${request}/BimSimWorkingPointsDetail/page`, params);
}
//获取工点模拟细节列表
export function BimSimWorkingPointsDetailList(params) {
  return http.get(`${request}/BimSimWorkingPointsDetail/list`, params);
}
//获取模型信息
export function BimMlodelGetByWame(params) {
  return http.get(`${request}/BimModel/GetByName`, params);
}
//获取工点模拟阶段信息
export function bimSimWorkingDescDetail(params) {
  return http.get(`${request}/BimSimWorkingDesc/detail`, params);
}
//获取工点模拟概况
export function BimSimWorkingGetSimId(params) {
  return http.get(`${request}/BimSimWorking/GetSimId`, params);
}

export function getBimDataBankDataTreeNodeList(params) {
  return http.get(`${request}/BimDataBankData/TreeNodeList`, params);
}
// 获取车流;
export function bimSimWorkingFlowDetail(params) {
  return http.get(`${request}/BimSimWorkingFlow/detail`, params);
}
// 根据成果，设计线，得到车道点;
export function getGetCarriagewayPoint(params) {
  return http.get(`${bimsso_url}/API/GetCarriagewayPoint`, params);
}

// 起终点桩号
export function getGetStake(params) {
  return http.get(`${bimsso_url}/API/GetStake`, params);
}
export function addListBimRoamPoints(params) {
  return http.post(`${request}/BimRoamPoints/addList`, params);
}
export function getBimProjectDetail(params) {
  return http.get(`${request}/BimProject/detail`, params);
}
export function getProjectTree(params) {
  return http.get(`${bimsso_url}/API/GetProjectTree`, params);
}
export function getCarriagewayPoints(params) {
  return http.post(`${bimsso_url}/API/GetCarriagewayPoints`, params);
}
export function BimTrafficSimulationNodeList(params) {
  return http.get(`${request}/BimTrafficSimulationNode/list`, params);
}
export function BimTrafficSimulationNodeDelete(params) {
  return http.post(`${request}/BimTrafficSimulationNode/delete`, params);
}
// 施工模拟
export function addBimConstructSimGrouping(params) {
  return http.post(`${request}/BimConstructSimGrouping/add`, params);
}
export function deleteBimConstructSimGrouping(params) {
  return http.post(`${request}/BimConstructSimGrouping/delete`, params);
}
export function editBimConstructSimGrouping(params) {
  return http.post(`${request}/BimConstructSimGrouping/edit`, params);
}
export function detailBimConstructSimGrouping(params) {
  return http.get(`${request}/BimConstructSimGrouping/detail`, params);
}

export function addBimConstructSimDetail(params) {
  return http.post(`${request}/BimConstructSimDetail/add`, params);
}
export function deleteBimConstructSimDetail(params) {
  return http.post(`${request}/BimConstructSimDetail/delete`, params);
}
export function editBimConstructSimDetail(params) {
  return http.post(`${request}/BimConstructSimDetail/edit`, params);
}
export function detailBimConstructSimDetail(params) {
  return http.get(
    `${request}/BimConstructSimDetail//BimConstructSimDetail/detail`,
    params
  );
}

// 标绘资源清理数据
export function getListUnusedFiles(params) {
  return http.get(`${request}/BimPlanScenesFile/listUnusedFiles`, params);
}
// 标绘资源删除
export function deletePlotResource(params) {
  return http.post(`${request}/BimPlanScenesFile/deleteFiles`, params);
}
// 标绘资源isUsed
export function updateFileIsUsed(params) {
  return http.post(`${request}/BimPlanScenesFile/updateFileIsUsed`, params);
}
// 标绘资源更新文件
export function updateFileEdit(params) {
  return http.post(`${request}/BimPlanPaintingFile/edit`, params);
}
export function updateFileDelete(params) {
  return http.post(`${request}/BimPlanPaintingFile/delete`, params);
}

export function getStakeByBLH(params) {
  return http.get(`${bimsso_url}/API/GetStakeByBLH`, params);
}

export function getLocationInformationByStake(params) {
  return http.get(`${bimsso_url}/API/GetLocationInformationByStake`, params);
}

export function getLocationInformationsByStake(params) {
  return http.get(`${bimsso_url}/API/GetLocationInformationsByStake`, params);
}

export function getQueryStake(params) {
  return http.get(`${request}/BimWuyuTender/queryStake`, params);
}

export function saveInitialView(params) {
  return http.post(`${request}/BimProject/SaveInitialView`, params);
}

// 单机版
export function chbimLocalVisPage(params) {
  return http.post(`https://chbim.ccshcc.cn/baseIP/ChbimLocalVis/add`, params);
}
